// src/components/CycleSettings/cycle-settings.config.ts

import { getPostWeldSettings, getPreHeatSettings, getPercentageTimerSettings } from '../helpers/index';
import { settingActions as postWeldSettingActions } from '../../PostWeldSettings/constants';
import { settingActions as percentageTimerSettingsActions } from '../../PercentageTimerSettings/constants';
import { preHeatSettingActions } from '../../PreHeatSettings/constants';
import CycleSettingsEnum from '../../../enums/cycle-setting.enum';

// Table header configurations
export const settingOptions = {
  [CycleSettingsEnum.PostWeld]: postWeldSettingActions,
  [CycleSettingsEnum.PreHeat]: preHeatSettingActions,
  [CycleSettingsEnum.PercentageTimer]: percentageTimerSettingsActions,
};

// Map of mode to the correct data transformation function
export const settingByMode = {
  [CycleSettingsEnum.PostWeld]: getPostWeldSettings,
  [CycleSettingsEnum.PreHeat]: getPreHeatSettings,
  [CycleSettingsEnum.PercentageTimer]: getPercentageTimerSettings,
};
